import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editZoneNotesPromise, EditZoneNotesPromiseParam } from 'src/utils/api';
import { QUERY_KEY_MAP } from 'src/constants/query-key';

export const useEditZoneNotes = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QUERY_KEY_MAP.useEditZoneNotes],
    mutationFn: editZoneNotesPromise,
  });

  const editZoneNotesAsync = async (param: EditZoneNotesPromiseParam) => {
    try {
      await mutateAsync(param);
      await queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_MAP.useGetZoneNotes, param.display_id],
      });
    } catch (e) {
      console.error(e);
    }
  };

  return {
    editZoneNotesAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
